export const UNDEFINED_ACCESS: accessLevel = 0;
export const PRIVATE_ACCESS: accessLevel = 100;
export const SHARED_ACCESS: accessLevel = 200;
export const PUBLIC_ACCESS: accessLevel = 500;

export type accessLevel = 0 | 100 | 200 | 500;
